import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MenuService } from './services/menu.service';
import { ScreenSizeService } from '../../services/screen-size.service';
import {CountryGlobalVariables} from '../../../shared/constants/country-global-variables';
import {LoginService} from '../../services/login.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MenuBadgeService } from './services/menu-badge.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService],
    standalone: false
})
export class MenuComponent implements OnInit, OnChanges, OnDestroy {
  @Input('menuItems') menuItems: any[];
  @Input('menuParentId') menuParentId: any;
  parentMenu: Array<any>;
  isMobile = false;
  unreadMessages = false;
  /** Dot on the Activities item: outstanding POS Integrity scans or unsubmitted activities. */
  activitiesBadge = false;
  requestedSurveys = false;
  private readonly onDestroy = new Subject<void>();

  constructor(
    public menuService: MenuService,
    private readonly screenSizeService: ScreenSizeService,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private readonly loginSvc: LoginService,
    private readonly menuBadgeService: MenuBadgeService,
  ) {
    this.matIconRegistry.addSvgIcon(
      'application-error-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/banner/application-error-icon.svg'
      )
    );
  }

  ngOnInit() {
    this.setParentMenu();
    this.screenSizeService.isSmall$.subscribe(
      (response) => (this.isMobile = response)
    );
    this.menuBadgeService.unreadMessages$
      .pipe(takeUntil(this.onDestroy))
      .subscribe(unreadMessages => {
        this.unreadMessages = unreadMessages;
      });
    this.menuBadgeService.activitiesNavBadge$
      .pipe(takeUntil(this.onDestroy))
      .subscribe(hasWork => {
        this.activitiesBadge = hasWork;
      });
    this.menuBadgeService.requestedSurveysBadge$
      .pipe(takeUntil(this.onDestroy))
      .subscribe(requestedSurveys => {
        this.requestedSurveys = requestedSurveys;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['menuItems'] || changes['menuParentId']) {
      this.setParentMenu();
    }
  }

  ngOnDestroy() {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  onClick(menuId: any, href?: string) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);
  }

  getMyTeamLogo(): string {
    if (this.loginSvc.isUkUser()) {
      return CountryGlobalVariables.UK.APP_LOGO;
    }
    return CountryGlobalVariables.US.APP_LOGO;
  }

  private setParentMenu(): void {
    this.parentMenu = (this.menuItems ?? []).filter(
      (item) => item.parentId == this.menuParentId
    );
  }
}
